import { useTranslation } from 'react-i18next';
import sortBy from 'lodash/sortBy';

import { SportType } from '__generated__/graphql';
import { useMemo } from 'react';
import GetSportTypesQuery from './GetSportTypesQuery';
import useQuery from '../../api/useQuery';

const useGroupedSportTypes = () => {
  const { t } = useTranslation();

  const { data } = useQuery(GetSportTypesQuery, {
    fetchPolicy: 'cache-and-network',
  });

  return useMemo(() => {
    const runningTypes = [
      SportType.running,
      SportType.trail_running,
    ];

    const cyclingTypes = [
      SportType.cycling,
      SportType.gravel_cycling,
      SportType.mountainbiking,
      SportType.cyclocross,
    ];

    const otherTypes = [
      ...sortBy(
        (data?.sportTypes || []).filter((category) => (
          category !== SportType.other
            && !runningTypes.includes(category)
            && !cyclingTypes.includes(category)
        )),
        (category) => t(`common:sport_types.${category}`),
      ),
    ];

    const allTypes = [
      '',
      ...runningTypes,
      ...cyclingTypes,
      ...otherTypes,
      SportType.other,
    ];

    return {
      runningTypes,
      cyclingTypes,
      otherTypes,
      allTypes,
    };
  }, [t, data]);
};

export default useGroupedSportTypes;
